// A block that opens from its own header, with the app's chevron in front of it: the header
// keeps its look (pass its class), and the browser's own disclosure triangle is hidden.
import type { ReactNode } from "react";

import { Chevron } from "./Chevron";
import styles from "./Fold.module.css";

export const Fold = ({
  head,
  headClassName,
  open,
  children,
}: {
  head: ReactNode;
  headClassName: string;
  /** Open on first render; the reader opens and closes it after. */
  open: boolean;
  children: ReactNode;
}) => (
  <details className={styles.fold} open={open}>
    <summary className={`${headClassName} ${styles.summary}`}>
      <Chevron tree />
      {head}
    </summary>
    {children}
  </details>
);
